import { Select } from 'component/Select'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const StandPagination = observer(() => {
  const demo = useDemo()
  const { form } = demo
  const { count, limit, limits } = form
  const options = limits.map((n) => ({ value: n.toFixed() }))

  const onLimit = useLatestCallback((value: string) => {
    demo.form.limit = parseInt(value)
  })

  return (
    <Space gap={16} minHeight={40} opposite wrap>
      <Space gap={8} pad={[0, 12]}>
        <Typo size={14} medium upper secondary>
          {i18n('ItemsCount')}
        </Typo>
        <Typo size={14} first medium>
          {count}
        </Typo>
      </Space>
      {count > limits[0] && (
        <Space gap={4}>
          <Typo size={14} medium upper secondary>
            {i18n('ShowBy')}
          </Typo>
          <Select value={limit.toFixed()} options={options} onChange={onLimit}>
            <Typo size={14} first medium>
              {limit.toFixed()}
            </Typo>
          </Select>
        </Space>
      )}
    </Space>
  )
})
